// material-ui
import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

// assets
import { IconWallet } from '@tabler/icons';
import { shouldForwardProp } from '@mui/system';
import { getChainToken, supportedChains, useWallet } from 'hooks/useWallet';
import walletHelpers from 'helpers/walletHelpers';
import useContract from 'hooks/useContract';

const OutlineButtonStyle = styled(Button, { shouldForwardProp })(({ theme }) => ({
  height: '50px',
  minWidth: 200,
  marginLeft: 16,
  paddingLeft: 16,
  paddingRight: 16,
  '& input': {
    paddingLeft: '4px !important',
    backgroundColor: 'background.default'
  },
  [theme.breakpoints.down('lg')]: {
    width: 250
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginLeft: 4,
    background: theme.palette.mode === 'dark' ? theme.palette.dark[800] : '#fff'
  }
}));

const renderContent = (wallet) => {
  if (wallet.walletMissing) return <Typography>Metamask wallet required</Typography>;
  if (!wallet.chainSupported) return <Typography>Switch Network</Typography>;
  if (!wallet.connected) return <Typography>Connect wallet</Typography>;

  return (
    <>
      {wallet.balance !== -1 && (
        <Typography color="text.accent">{`${wallet.balance.toFixed(2)} ${getChainToken(wallet.chainId)}`}&nbsp;&nbsp;&nbsp;</Typography>
      )}
      <Typography>{walletHelpers.getMinifiedAddress(wallet.address)}</Typography>
    </>
  );
};

const Wallet = () => {
  // const contract = useContract();
  const wallet = useWallet();
  const onWalletClick = () => {
    if (wallet.walletMissing) window.open('https://metamask.io/download.html', '_blank', 'noopener, noreferrer');
    else if (!wallet.chainSupported) wallet.switchNetwork(supportedChains[0]);
    else if (!wallet.connected) wallet.connect();
  };
  return (
    <>
      <Box sx={{ display: { md: 'block' } }}>
        <OutlineButtonStyle onClick={onWalletClick} variant="contained" startIcon={<IconWallet />}>
          {renderContent(wallet)}
        </OutlineButtonStyle>
      </Box>
    </>
  );
};

export default Wallet;
